import Big from 'big.js'

import { Box, Flex, Totals } from '@sequencehq/core-components'

import { CreditNote } from 'CreditNotes/types'

import { ApplyTotals } from './applyCreditNote.helpers'

type Props = {
  creditNote: CreditNote
  totals: ApplyTotals
}

/**
 * The credit note's own totals, less the credit being applied to each selected
 * invoice, ending in the balance that would be left over.
 */
export const ApplyCreditTotalsSection = ({ creditNote, totals }: Props) => (
  <Flex
    justifyContent="flex-end"
    data-testid="creditNote.applyCredits.totals"
    width="100%"
  >
    <Box width="320px">
      <Totals currency={creditNote.currency}>
        <Totals.Row title="Credit subtotal" amount={creditNote.netTotal} />
        <Totals.Row title="Tax" amount={creditNote.totalTax} />
        <Totals.Divider />
        <Totals.Row title="Credit total" amount={creditNote.grossTotal} />
        {totals.appliedByRow.length > 0 && <Totals.Divider />}
        {totals.appliedByRow.map(applied => (
          <Totals.Row
            key={applied.rowId}
            title={`Credit applied - ${applied.invoiceNumber}`}
            amount={negateAmount(applied.amount)}
            testId={`creditNote.applyCredits.totals.applied.${applied.invoiceNumber}`}
          />
        ))}
        <Totals.Divider strong />
        <Totals.Total
          title="Credit remaining"
          amount={totals.creditRemaining}
          testId="creditNote.applyCredits.creditRemaining"
        />
      </Totals>
    </Box>
  </Flex>
)

const negateAmount = (amount: string): string =>
  new Big(amount).times(-1).toFixed(2)
